// src/domain/types.ts
export type UUID = string & { readonly __brand: unique symbol };
export const uid = () => crypto.randomUUID() as UUID;

export enum Sport { NBA = 'NBA', NHL = 'NHL' }
export enum Side  { OVER = 'over', UNDER = 'under' }
export enum ParlayStatus { PENDING = 'pending', GREEN = 'green', RED = 'red', VOID = 'void' }
export enum PickStatus   { PENDING = 'pending', WON = 'won', LOST = 'lost', PUSH = 'push', VOID = 'void' }
export enum TxKind { DEPOSIT = 'deposit', WITHDRAW = 'withdraw', STAKE = 'stake', PAYOUT = 'payout', ADJUSTMENT = 'adjustment' }

// ── Pick individual ──
export interface BasePick {
  id: UUID;
  sport: Sport;
  player: string;
  market: string;
  statKey: string;
  line: number;
  side: Side;
  odds: number;
  game: string;
  startISO: string;
  hitRatePct?: number;
  overHitRatePct?: number;
  underHitRatePct?: number;
  overHits?: number;
  overSample?: number;
  underHits?: number;
  underSample?: number;
  historyValues?: number[];
  historyDates?: string[];
  createdAt?: string;
}

// ── Parlay ──
export interface Parlay {
  id: UUID;
  picks: BasePick[];
  combinedOdds: number;
  combinedHitRate: number;
  stake: number;
  potentialReturn: number;
  status: ParlayStatus;
  createdAt: string;
  updatedAt: string;
  resolvedAt?: string;
}

// ── Entrada unificada no Tracker ──
export type TrackerEntry =
  | { type: 'pick';   data: BasePick & { status: PickStatus; resultValue?: number; settledAt?: string; stake: number } }
  | { type: 'parlay'; data: Parlay };

// ── Bankroll ──
export interface BankrollState {
  id?: string;
  initial: number;
  current: number;
  openStake: number;
  history: BankrollTx[];
}

export interface BankrollTx {
  id: UUID;
  ts: string;
  kind: TxKind;
  refType: 'pick' | 'parlay';
  refId: UUID;
  amount: number;
  balanceAfter: number;
  note?: string;
}

export interface EntityBase {
  id: UUID;
  createdAt: string;
  updatedAt: string;
}
